'use client';

import React from 'react';

import Contacts2 from '@/components/elements/contacts2';
import Icon2 from '@/components/elements/icon/icon2';
import { useToggle } from '@/hooks/use-toggle';
import { useTranslation } from '@/i18n/client';
import { WithLocale } from '@/types/platform-data';

export default function ExpanderContacts(props: WithLocale) {
    const { t: tCo } = useTranslation(props.lang, 'common');

    const { toggleValue, handleToggle } = useToggle(false);

    return (
        <>
            <button
                className="md:text-regular flex w-full gap-2 whitespace-nowrap px-4 py-4 text-sm"
                onClick={handleToggle}
            >
                <span>{tCo('footer.contacts.title')}</span>
                <Icon2
                    name="phi-caret-down-16"
                    iconClass={`h-5 w-5 transition-transform ${toggleValue ? '-scale-y-100' : ''}`}
                />
            </button>
            {toggleValue && <Contacts2 size={5} country={props.country?.code} className="w-full px-4 py-4" />}
        </>
    );
}
